import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { HttpErrorDisplayService } from '../services/http-error-display.service';

@Injectable()
export class ErrorHttpInterceptor implements HttpInterceptor {

    constructor(private httpErrorDisplay: HttpErrorDisplayService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => {
                try {
                    const isCouponPreviewRequest = request.url.includes('/coupons/preview');
                    if (!isCouponPreviewRequest) {
                        this.httpErrorDisplay.showErrorToUser(error);
                    }
                } catch {
                    // Never mask the original HTTP error if display fails.
                }
                return throwError(() => error);
            })
        );
    }
}
